"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LazyImage;
exports.imgPropShape = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useImageLoading = require("../hooks/use-image-loading.js");
const imgPropShape = exports.imgPropShape = {
  url: _propTypes.default.string,
  altText: _propTypes.default.string,
  width: _propTypes.default.number,
  height: _propTypes.default.number
};
/**
 * LazyImage
 * @module LazyImage
 *
 * @param {Object} props props
 * @param {String} props.key unique key for items
 * @param {String} props.src Image Source
 * @param {String} props.dataResponsive Image data-responsive
 * @param {String} props.dataCy Image data-cy
 * @param {String} props.alt Image Alt Text
 * @param {Number} props.height image height
 * @param {Number} props.width image width
 * @param {String} props.dataSrc data src
 * @param {Boolean} props.initialInView containerClassName
 * @param {String} props.containerClassName containerClassName
 * @returns {React.ReactFragment} LazyImage Component
 * @public
 */

function LazyImage({
  key,
  className,
  style,
  dataResponsive,
  dataCy = 'image',
  url,
  altText,
  height,
  width,
  initialInView,
  dataSrc,
  containerClassName,
  loading = _useImageLoading.loadingOptions.LAZY,
  rootMargin = '200px 0px',
  threshold = 0
}) {
  const {
    ref,
    getImageSrc
  } = (0, _useImageLoading.useImageLoading)({
    loading,
    rootMargin,
    threshold,
    initialInView
  });

  // see https://stackoverflow.com/questions/6018611/smallest-data-uri-image-possible-for-a-transparent-image
  // For this image, we use this tiny image to reduce rendered code size and also to
  // allow the image to apply the height and width to help prevent Layout shift.

  let srcAttr = getImageSrc(url);
  const dataResponsiveAttr = dataResponsive ? {
    'data-responsive': dataResponsive
  } : {};
  srcAttr = dataSrc ? {
    'data-src': dataSrc
  } : srcAttr;
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: containerClassName,
    "data-cy": "img-wrapper"
  }, /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({
    className: className,
    style: style,
    "data-cy": dataCy,
    key: key,
    alt: altText,
    height: height,
    width: width
  }, srcAttr, dataResponsiveAttr)));
}
LazyImage.propTypes = {
  ...imgPropShape,
  key: _propTypes.default.number,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  dataResponsive: _propTypes.default.string,
  dataCy: _propTypes.default.string,
  initialInView: _propTypes.default.bool,
  dataSrc: _propTypes.default.string,
  containerClassName: _propTypes.default.string,
  loading: _propTypes.default.oneOf(Object.values(_useImageLoading.loadingOptions)),
  rootMargin: _propTypes.default.string,
  threshold: _propTypes.default.oneOf([_propTypes.default.number, _propTypes.default.array])
};